"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalancePlanEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const common_styled_components_1 = require("../../../common-styled-components");
const useFetch_1 = __importDefault(require("../../../../hooks/useFetch"));
const apiUtils_1 = require("../../../../util/apiUtils");
const react_select_1 = __importDefault(require("react-select"));
const NumberInput_1 = require("../../../generic/NumberInput");
const YearContext_1 = require("../../../../contexts/YearContext");
const react_1 = require("react");
const emptyOption = { label: "Select ship", value: null };
const BalancePlanEditor = ({ state, updateValue, modalType, shipId, }) => {
    const [ships, _, setShipsBody] = (0, useFetch_1.default)("admin/ships.json", undefined, true);
    const { selectedYear } = (0, YearContext_1.useYear)();
    (0, react_1.useEffect)(() => {
        setShipsBody(JSON.stringify({ year: selectedYear }));
    }, [selectedYear]);
    if (modalType === "remove") {
        return (0, jsx_runtime_1.jsx)("div", { children: "Remove balance plan?" });
    }
    const shipOptions = [emptyOption].concat(ships.status === apiUtils_1.LoaderStatus.Success
        ? ships.data.map((s) => ({
            label: s.name,
            value: s.id,
        }))
        : []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Ship" }), (0, jsx_runtime_1.jsx)(react_select_1.default, { options: shipOptions, onChange: (newValue) => updateValue("ship_id", newValue?.value), value: shipOptions.find((c) => c.value === state.ship_id) ?? emptyOption, isOptionSelected: (option) => option.value === state.ship_id, isDisabled: shipId !== undefined })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Year" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: state.year ?? "", onChange: (newValue) => updateValue("year", newValue) })] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.Selector, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SelectorLabel, { children: "Planned balance" }), (0, jsx_runtime_1.jsx)(NumberInput_1.NumberInput, { value: state.balance ?? "", onChange: (newValue) => updateValue("balance", newValue) })] })] }));
};
exports.BalancePlanEditor = BalancePlanEditor;
